import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { DiagnosticsComponent } from './components-components/DiagnosticsComponent';
import { DiagnosticsComponentProvider } from './contexts/DiagnosticsComponentContext';
import {
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AppProvider } from './contexts/Context';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { LLMDiagnoseProvider } from './contexts/LLMDiagnoseContext';
import { PMSIntegrationUserProvider as AuthUserProvider } from './contexts/AuthUserContext';
import { PatientListProvider } from './contexts/PatientListContext';

const theme = {
  spacing: 8,
  typography: {
    h4: {
      marginTop: '1em',
    },
    h5: {
      marginTop: '1em',
    },
  },
};

// resolve the current path as base path (without query string or fragments)
const currentPath = window.location.pathname;

export const ComponentsRoot = () => {
  const { component, sessionId, searchParams } = (window as any)
    .__componentsInitialData;

  console.log('currentPath', currentPath);
  return (
    <AuthUserProvider>
      <BrowserRouter basename="/">
        <CssBaseline />
        <ThemeProvider theme={createTheme(theme)}>
          <StyledEngineProvider>
            <AppProvider>
              <LLMDiagnoseProvider>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  {component === 'diagnostics' && sessionId && (
                    <PatientListProvider>
                      <DiagnosticsComponentProvider>
                        <DiagnosticsComponent
                          sessionId={sessionId}
                          searchParams={searchParams}
                        />
                      </DiagnosticsComponentProvider>
                    </PatientListProvider>
                  )}
                </LocalizationProvider>
              </LLMDiagnoseProvider>
            </AppProvider>
          </StyledEngineProvider>
        </ThemeProvider>
      </BrowserRouter>
    </AuthUserProvider>
  );
};
